export default {
    order: 10,
    apply: (permissionsMap = {}, grantedPermissions = [], context = {}) => {
        const out = { ...permissionsMap };

        const { account = {} } = context;
        const { features = [] } = account;

        // reports has moved from permission to feature flag
        // But to keep backward compatibility, we infer the reports permission from the feature flag
        if(features.includes('view_reports')) {
            out.reports = { view: true };
        }

        // if user has admin role on at least one tag, they get the view_tags feature
        // which we convert to read/write tags permissions here for backward compatibility
        if(features.includes('view_tags')) {
            out.tags = { read: true, write: true };
        }

        // If access to reports is granted, also grant read access to coaching
        if(out.reports?.view) {
            out.coaching = { read: true };
        }

        // If access to tags is granted, also grant access to users, ravens and coaching
        if(out.tags?.write) {
            out.users = { read: true, write: true };
            out.ravens = { read: true, write: true };
            out.coaching = { read: true, write: true };
        }

        return out;
    }
}